import type { FormValues } from 'hb-react/shared/apps/Events/pages/Booking/pages/Registration/types';
import type {
  Cart,
  TicketCartItem,
} from 'hb-react/shared/components/ShoppingCard/hooks/v2';

export const requiresBillingPage = (cart?: Cart, values?: FormValues) => {
  if (cart?.total_in_cents && cart.total_in_cents > 0) {
    return true;
  }

  const freeTicketsAttendees = Object.values(
    (cart?.cart_items || [])
      ?.filter(
        (item): item is TicketCartItem =>
          item.line_itemable_type === 'NetworkEvents::Ticket' &&
          item.total_in_cents === 0,
      )
      .map(({ metadata }, index) => {
        const firstname =
          metadata.event?.firstname || values?.attendees?.[index]?.firstname;
        const lastname =
          metadata.event?.lastname || values?.attendees?.[index]?.lastname;
        const email =
          metadata.event?.email || values?.attendees?.[index]?.email;

        return [firstname, lastname, email].join('').toLowerCase() || index;
      })
      .reduce(
        (attendees, attendee) => ({
          ...attendees,
          [attendee]: attendee,
        }),
        {},
      ),
  );

  return freeTicketsAttendees.length > 1;
};
